import React, { useCallback, useMemo, useState } from 'react';
import Input from './Input';
import Dropdown from '../../../common/dropdown/Dropdown';
import countryList from 'react-select-country-list';
import DateInput from '../../global/DateInput';
import { SharesProgressBar } from './SharesProgressBar';
import { TDirectorInfo } from '../../../types';
import Button2 from '../../global/Button2';
import { validateEmail } from '../../../lib/validateEmail';
import { trash_red } from '../../../assets/images/dashboard-business';
import DeleteModal from '../BusinessAddres/DeleteModal';
import Button from '../../global/Button';

type TProps = {
  shareholders: TDirectorInfo[];
  currentShareholder: number;
  setActiveStage: React.Dispatch<React.SetStateAction<number>>;
  activeStage: number;
  setShareholders: React.Dispatch<React.SetStateAction<TDirectorInfo[]>>;
  isStageOneComplete: boolean;
  director?: boolean;
  setCurrentShareholder: React.Dispatch<React.SetStateAction<number>>;
};
const PersonalData = ({
  director = false,
  currentShareholder,
  setActiveStage,
  shareholders,
  setShareholders,
  isStageOneComplete,
  setCurrentShareholder,
}: TProps) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const countries = useMemo(() => countryList().getData(), []);

  const [submitting, setSubmitting] = useState(false);
  const displayErrorMsg = (errorText: string, variable: string) => {
    if (submitting && !variable) {
      return <div className='text-[red] text-[11px]'>{errorText}</div>;
    }
  };

  return (
    <div>
      <div className='mr-[4vw] h-[100%] mb-[50px]'>
        <div className='sl:flex w-full sl:gap-[5%]'>
          <Input
            label='First name'
            value={shareholders?.[currentShareholder]?.firstName}
            style='sl:w-[30%]'
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const shareholders_ = shareholders?.[currentShareholder]
                ? shareholders
                : [...shareholders, {} as TDirectorInfo];
              const shareholder = shareholders_?.map((shareholder, ind) => {
                if (currentShareholder === ind) {
                  return {
                    ...shareholder,
                    firstName: e.target.value.replace(/[0-9]/g, ''),
                  };
                }
                return shareholder;
              });
              setShareholders(shareholder);
            }}
            type='text'
            errorDiv={displayErrorMsg(
              'First name cannot be empty',
              shareholders?.[currentShareholder]?.firstName,
            )}
          />
          <Input
            label='Middle name (optional)'
            value={shareholders?.[currentShareholder]?.middleName}
            style='sl:w-[30%]'
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const shareholders_ = shareholders?.[currentShareholder]
                ? shareholders
                : [...shareholders, {} as TDirectorInfo];
              const shareholder = shareholders_?.map((shareholder, ind) => {
                if (currentShareholder === ind) {
                  return {
                    ...shareholder,
                    middleName: e.target.value.replace(/[0-9]/g, ''),
                  };
                }
                return shareholder;
              });
              setShareholders(shareholder);
            }}
            type='text'
          />

          <Input
            label='Last name'
            value={shareholders?.[currentShareholder]?.lastName}
            style='sl:w-[30%]'
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const shareholders_ = shareholders?.[currentShareholder]
                ? shareholders
                : [...shareholders, {} as TDirectorInfo];
              const shareholder = shareholders_?.map((shareholder, ind) => {
                if (currentShareholder === ind) {
                  return {
                    ...shareholder,
                    lastName: e.target.value.replace(/[0-9]/g, ''),
                  };
                }
                return shareholder;
              });
              setShareholders(shareholder);
            }}
            type='text'
            errorDiv={displayErrorMsg(
              'Last name cannot be empty',
              shareholders?.[currentShareholder]?.lastName,
            )}
          />
        </div>

        <div className='sl:flex w-full sl:gap-[5%]'>
          <div className='sl:w-[30%] mb-4'>
            <Dropdown
              hideStar
              className='border !border-[#B8C9C9] rounded-[2px] !h-[52px] '
              label='Nationality'
              required
              placeholder={shareholders?.[currentShareholder]?.nationality}
              labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
              options={countries.map((country) => {
                return {
                  value: country.label,
                  label: country.label,
                };
              })}
              width='100%'
              setSelectedOption={(e: { value: string; label: string }) => {
                const shareholders_ = shareholders?.[currentShareholder]
                  ? shareholders
                  : [...shareholders, {} as TDirectorInfo];
                const shareholder = shareholders_?.map((shareholder, ind) => {
                  if (currentShareholder === ind) {
                    return {
                      ...shareholder,
                      nationality: e.value,
                    };
                  }
                  return shareholder;
                });
                setShareholders(shareholder);
              }}
            />
            {displayErrorMsg(
              'Nationality cannot be empty',
              shareholders?.[currentShareholder]?.nationality,
            )}
          </div>
          <Input
            label={
              <div className='flex justify-between'>
                <div>Email Address</div>
                {shareholders?.[currentShareholder]?.email &&
                  !validateEmail(shareholders?.[currentShareholder]?.email) && (
                    <div className='text-[10px] text-[red]'>Invalid email</div>
                  )}
              </div>
            }
            value={shareholders?.[currentShareholder]?.email}
            style='sl:w-[30%]'
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const shareholders_ = shareholders?.[currentShareholder]
                ? shareholders
                : [...shareholders, {} as TDirectorInfo];
              const shareholder = shareholders_?.map((shareholder, ind) => {
                if (currentShareholder === ind) {
                  return {
                    ...shareholder,
                    email: e.target.value,
                  };
                }
                return shareholder;
              });
              setShareholders(shareholder);
            }}
            type='email'
            errorDiv={displayErrorMsg(
              'Email cannot be empty',
              shareholders?.[currentShareholder]?.email,
            )}
          />

          <div className='sl:w-[30%] mb-4'>
            <DateInput
              className='!h-[52px] !border-[#B8C9C9]'
              placeholderText='Date of Birth'
              value={shareholders?.[currentShareholder]?.birthDate}
              labelStyles='!pb-[5px]'
              onChange={(e: any) => {
                const shareholders_ = shareholders?.[currentShareholder]
                  ? shareholders
                  : [...shareholders, {} as TDirectorInfo];
                const shareholder = shareholders_?.map((shareholder, ind) => {
                  if (currentShareholder === ind) {
                    return {
                      ...shareholder,
                      birthDate: e._d,
                    };
                  }
                  return shareholder;
                });
                setShareholders(shareholder);
              }}
            />
            {displayErrorMsg(
              'Date of birth cannot be empty',
              shareholders?.[currentShareholder]?.birthDate,
            )}
          </div>
        </div>

        <div className='sl:flex w-full sl:gap-[5%]'>
          <div className='sl:w-[30%] mb-4'>
            <Dropdown
              hideStar
              className='border !border-[#B8C9C9] rounded-[2px] !h-[52px] '
              label='Gender'
              required
              placeholder={shareholders?.[currentShareholder]?.gender}
              labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
              options={[
                { value: 'Male', label: 'Male' },
                { value: 'Female', label: 'Female' },
              ]}
              width='100%'
              setSelectedOption={(e: { value: string; label: string }) => {
                const shareholders_ = shareholders?.[currentShareholder]
                  ? shareholders
                  : [...shareholders, {} as TDirectorInfo];
                const shareholder = shareholders_?.map((shareholder, ind) => {
                  if (currentShareholder === ind) {
                    return {
                      ...shareholder,
                      gender: e.value,
                    };
                  }
                  return shareholder;
                });
                setShareholders(shareholder);
              }}
            />
            {displayErrorMsg('Gender cannot be empty', shareholders?.[currentShareholder]?.gender)}
          </div>

          <Input
            label={
              <div className='flex justify-between'>
                <div>Phone Number</div>
                {shareholders?.[currentShareholder]?.phone &&
                  shareholders?.[currentShareholder]?.phone?.length !== 11 && (
                    <div className='text-[10px] text-[red]'>Invalid phone number</div>
                  )}
              </div>
            }
            value={shareholders?.[currentShareholder]?.phone}
            style='sl:w-[30%]'
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const re = /^[0-9\b]+$/;
              if (e.target.value === '' || re.test(e.target.value)) {
                const shareholders_ = shareholders?.[currentShareholder]
                  ? shareholders
                  : [...shareholders, {} as TDirectorInfo];
                const shareholder = shareholders_?.map((shareholder, ind) => {
                  if (currentShareholder === ind) {
                    return {
                      ...shareholder,
                      phone: e.target.value,
                    };
                  }
                  return shareholder;
                });
                setShareholders(shareholder);
              }
            }}
            minLength={11}
            maxLength={11}
            bottomText={`(Enter Nigerian phone number with 0 at the beginning e.g 090...)`}
            errorDiv={displayErrorMsg(
              'Phone number cannot be empty',
              shareholders?.[currentShareholder]?.phone,
            )}
          />

          <Input
            label={
              <div className='flex justify-between'>
                <div
                  className={[
                    shareholders?.[currentShareholder]?.identityNumber &&
                      shareholders?.[currentShareholder]?.identityNumber?.length !== 11 &&
                      'sl:w-[60%] sl:truncate',
                  ].join(' ')}
                >
                  National Identity Number (NIN)
                </div>
                {shareholders?.[currentShareholder]?.identityNumber &&
                  shareholders?.[currentShareholder]?.identityNumber?.length !== 11 && (
                    <div className='text-[10px] text-[red]'>must be 11 digits</div>
                  )}
              </div>
            }
            value={shareholders?.[currentShareholder]?.identityNumber}
            style='sl:w-[30%]'
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const re = /^[0-9\b]+$/;
              if (e.target.value === '' || re.test(e.target.value)) {
                const shareholders_ = shareholders?.[currentShareholder]
                  ? shareholders
                  : [...shareholders, {} as TDirectorInfo];
                const shareholder = shareholders_?.map((shareholder, ind) => {
                  if (currentShareholder === ind) {
                    return {
                      ...shareholder,
                      identityNumber: e.target.value,
                    };
                  }
                  return shareholder;
                });
                setShareholders(shareholder);
              }
            }}
            maxLength={11}
            bottomText={`(National ID is the only acceptable ID for registrations at CAC)`}
            errorDiv={displayErrorMsg(
              'NIN cannot be empty',
              shareholders?.[currentShareholder]?.identityNumber,
            )}
          />
        </div>
      </div>

      {!director && (
        <SharesProgressBar
          currentShareholder={currentShareholder}
          shareholders={shareholders}
          setShareholders={setShareholders}
          submitting={submitting}
          displayErrorMessage={displayErrorMsg}
        />
      )}

      {director ? (
        <div className='sl:flex justify-between my-[65px] mr-[4vw]'>
          <Button
            className='px-2 md:px-5 !py-[10px] !bg-[#768396] text-[11px] mb-2 sl:mb-0 text-white border-[0px] rounded-2 '
            size='sm'
            underline={false}
            theme='secondary'
            onClick={() => setCurrentShareholder((prev) => prev - 1)}
          >
            PREVIOUS
          </Button>
          <div className='flex justify-between gap-2'>
            <Button2
              className='!px-2 !md:px-5 !py-[10px] text-[11px] text-white border-[0px] rounded-2 '
              size='sm'
              underline={false}
              theme='primary'
              // disabled={!isStageOneComplete}
              onClick={() => {
                if (isStageOneComplete) {
                  setActiveStage((prev) => prev + 1);
                }
                setSubmitting(true);
              }}
            >
              ADD RESIDENTIAL ADDRESS
            </Button2>

            {director && (
              <Button2
                className='!px-2 !md:px-5 !gap-1  !py-[10px] text-[11px] rounded-2 '
                size='sm'
                underline={false}
                theme='danger'
                onClick={() => {
                  setShowDeleteModal(true);
                }}
                icon={trash_red}
              >
                {`REMOVE DIRECTOR`}
              </Button2>
            )}
          </div>
        </div>
      ) : (
        <div className='flex justify-between my-[65px] mr-[4vw] gap-1'>
          <Button2
            className='!px-2 !md:px-5 !py-[10px] text-[11px] text-white border-[0px] rounded-2 '
            size='sm'
            underline={false}
            theme='primary'
            // disabled={!isStageOneComplete}
            onClick={() => {
              if (isStageOneComplete) {
                setActiveStage((prev) => prev + 1);
              }
              setSubmitting(true);
            }}
          >
            ADD RESIDENTIAL ADDRESS
          </Button2>

          {!director && !!shareholders?.length && (
            <Button2
              className='!px-2 !md:px-5 !gap-1  !py-[10px] text-[11px] rounded-2 '
              size='sm'
              underline={false}
              theme='danger'
              onClick={() => {
                setShowDeleteModal(true);
              }}
              icon={trash_red}
            >
              {`REMOVE SHAREHOLDER`}
            </Button2>
          )}
        </div>
      )}

      <DeleteModal
        description='Are you sure you want to delete'
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        deleteFn={() => {
          const deets = shareholders?.filter((shareholder, index) => {
            if (index !== currentShareholder) {
              return shareholder;
            }
          });
          setShareholders(deets);

          if (shareholders.length > 0) {
            setCurrentShareholder(0);
          } else {
            if (director) {
              setCurrentShareholder(-1);
            } else {
              setShareholders([{} as TDirectorInfo]);
            }
          }
        }}
      />
    </div>
  );
};

export default PersonalData;
